import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';

const Upsell = new ReduxAsyncAction('UPSELL');
Upsell.registerRequest(function () {
  return dash_api.get(`/v1/app/upsell/upsell-data`).then(({ data }) => data);
});

export const upsell = Upsell.request;
export const UPSELL = Upsell.constants;
